import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormItem, FormLabel, FormInputChoiceGroup } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';
import { Radio } from './Radio.js';
import { RadioGroupContext } from './context.js';

var _excluded = ["required"],
  _excluded2 = ["label", "options", "helper", "feedback", "informed", "children", "disabled", "id", "caption", "tooltip", "layout"],
  _excluded3 = ["onChange"];
var RadioGroup = function RadioGroup(_ref) {
  var required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useField = useField(_objectSpread2(_objectSpread2({}, props), {}, {
      required: required
    })),
    fieldState = _useField.fieldState,
    fieldApi = _useField.fieldApi,
    render = _useField.render,
    userProps = _useField.userProps;
  var label = userProps.label,
    options = userProps.options,
    helper = userProps.helper,
    feedback = userProps.feedback,
    informed = userProps.informed,
    children = userProps.children,
    disabled = userProps.disabled,
    id = userProps.id,
    caption = userProps.caption,
    tooltip = userProps.tooltip,
    layout = userProps.layout,
    inputProps = _objectWithoutProperties(userProps, _excluded2);
  var showError = fieldState.showError,
    error = fieldState.error;
  var groupContext = _objectSpread2({
    id: id,
    radioGroupApi: fieldApi,
    radioGroupState: fieldState
  }, inputProps);
  var _ref2 = informed || {};
    _ref2.onChange;
    _objectWithoutProperties(_ref2, _excluded3);
  return render( /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: groupContext
  }, /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    disabled: disabled
  }, label ? /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    caption: caption,
    tooltip: tooltip
  }, label) : null, /*#__PURE__*/React.createElement(FormInputChoiceGroup, {
    layout: layout,
    type: "radio"
  }, children == null ? options.map(function (option) {
    return /*#__PURE__*/React.createElement(Radio, _extends({}, option, {
      key: option.value
    }));
  }) : children), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError
  }))));
};

export { RadioGroup };
